module.exports = __webpack_public_path__ + "img/ch14_06_躲鹅.1e61f304.jpg";